webpackJsonp([0],{

/***/ "+pyK":
/***/ (function(module, exports) {

module.exports = {"images":[{"fileName":"ideum-starbucks--4x5--600.jpg","caption":"Starbucks Roastery application showcasing high-quality reserve coffees."},{"fileName":"ideum-beer--4x5--600.jpg","caption":"Interactive beer tasting application using Ideum's Tangible Engine Media Creation software."},{"fileName":"ideum-mizrahi--4x5--600.jpg","caption":"Explore Sam Mizrahi's The One tower by Foster + Partners with an interactive multitouch application."},{"fileName":"ideum-presenter-austinProper--4x5--600.jpg","caption":"State-of-the-art sales gallery for Austin Proper allows visitors to explore real estate in new and engaging ways."},{"fileName":"ideum-colossus-table-01--4x5--600.jpg","caption":"Smithsonian National Museum of the American Indian (NMAI) and Ideum collaborate on developing a 3D reconstruction of the ancient Inka capital of Cusco."},{"fileName":"ideum-portrait-01--4x5--600.jpg","caption":"Faces To Go With Names is an immersive experience that pays tribute to Iowa’s fallen heroes by sharing their stories."}]}

/***/ }),

/***/ "/oiM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "2oac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_vue__ = __webpack_require__("dOjO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_255fccfa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slider_vue__ = __webpack_require__("xjma");
function injectStyle (ssrContext) {
  __webpack_require__("PCjG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-255fccfa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_255fccfa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8y8H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AL0q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Agty":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Card-wrapper",class:_vm.classes},[_c('div',{staticClass:"Card py-5 px-3 px-sm-5 text-center text-lg-left"},[_vm._t("Card-title"),_vm._v(" "),_vm._t("Card-body"),_vm._v(" "),_vm._t("Card-button")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BTA2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container Section Section--story"},[_c('div',{staticClass:"row Story Story--first"},[_c('div',{staticClass:"col-md-7 Story-img Reveal--left"},[_c('div',{staticClass:"Intrinsic-wrapper Intrinsic-wrapper--5x4"},[_c('img',{staticClass:"Intrinsic-item lazyload",attrs:{"data-src":'./static/images/' + 'ideum-01--5x4--600.jpg',"alt":"Ideum employees testing interactive applications on an Ideum-made multitouch Platform table."}})])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"Background Background--light"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-5 mt-3 pl-lg-5 Story-card Story-card--dark Reveal--right"},[_c('h2',{staticClass:"Story-card-title Story-card-title--highlight"},[_vm._v("Ideum")]),_vm._v(" "),_c('p',[_vm._v("\n        Ideum is a creative company focused on emerging technology and on designing public installations and products that can create meaningful and compelling user experiences. We have designed and developed our own multitouch tables and hardened touch displays and rent them directly to clients throughout the United States. Our high-quality touch tables have been used by Fortune 500 companies at hundreds of trade shows and events.\n      ")]),_vm._v(" "),_c('a',{staticClass:"Button Button--emerald mt-4",attrs:{"target":"_blank","href":"https://ideum.com/company","title":"Learn more about Ideum","rel":"noopener"}},[_c('span',{staticClass:"Button-text"},[_vm._v("Learn About Ideum")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_672fb516_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("IHu5");
function injectStyle (ssrContext) {
  __webpack_require__("AL0q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_672fb516_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Drc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jump_js__ = __webpack_require__("q7+D");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      currentSection: null,
      menuIsOpen: false,
      scrollIsHome: true
    };
  },


  computed: {
    sections: function sections() {
      var sectionNodes = document.querySelectorAll('.Section');
      return sectionNodes.length;
    }
  },

  created: function created() {
    window.addEventListener('scroll', this.menuCollapse);
  },
  mounted: function mounted() {
    console.dir(document.querySelectorAll('.Section'));
    this.menuCollapse();
  },


  methods: {
    functionHandler: function functionHandler(fn1, fn2) {
      fn1();
      fn2();
    },
    jumpToHome: function jumpToHome() {
      Object(__WEBPACK_IMPORTED_MODULE_0_jump_js__["a" /* default */])('#app');
    },
    jumpToSection: function jumpToSection(section) {
      var selector = '.Section--' + section;
      Object(__WEBPACK_IMPORTED_MODULE_0_jump_js__["a" /* default */])(selector, {
        offset: -80
      });
    },
    menuCollapse: function menuCollapse() {
      var scrollY = document.body.scrollTop || window.pageYOffset;
      var width = document.body.offsetWidth;
      if (scrollY > 0 && width >= 767) {
        this.scrollIsHome = false;
      } else {
        this.scrollIsHome = true;
      }
    },
    mobileNavigation: function mobileNavigation(section) {
      this.toggleMenu();
      this.toggleScroll();
      this.jumpToSection(section);
    },
    toggleScroll: function toggleScroll() {
      var body = document.getElementsByTagName('body');
      if (this.menuIsOpen) {
        body[0].setAttribute('style', 'overflow: hidden;');
      } else {
        body[0].removeAttribute('style', 'overflow: hidden;');
      }
    },
    toggleMenu: function toggleMenu() {
      this.menuIsOpen = !this.menuIsOpen;
    }
  }
});

/***/ }),

/***/ "FnhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("/oiM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75955d24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("msts");
function injectStyle (ssrContext) {
  __webpack_require__("kMkV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75955d24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75955d24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HNjT":
/***/ (function(module, exports) {

module.exports = [{"name":"Platform Touch Table","title":"Platform 55” and 65” Multitouch Tables","body":"Platform multitouch tables are perfect for collaboration and allow you to show off your products and ideas in innovative ways. The Platform has a 4K Ultra HD LG commercial display and 3M™ touch technology supporting 80 simultaneous touch points. The Platform includes a powerful computer system with Intel® Core™ processors and NVIDIA® discrete graphics card. The Platform requires no assembly, just plug-it-in and turn it on.","links":[{"title":"Explore the Platform Touch Table","href":"https://ideum.com/touch-tables/platform/"}],"images":[{"fileName":"ideum-platform--square--600.jpg","caption":"Stanford Linear Accelerator Center Orientation table orients facility visitors."},{"fileName":"ideum-platform-01--1x1--600.jpg","caption":"Platform: a turnkey, all-in-one high-performance inter­active table with 3M™ touch tech­nol­ogy."},{"fileName":"ideum-platform-pathogen--square--600.jpg","caption":"Engage your audience with interactive touch tables."},{"fileName":"ideum-tangible--1x1--635.jpg","caption":"Custom tangibles expand application potential and enhance user experiences."}]},{"name":"Smart Coffee Tables","title":"Pico 55” Touch Coffee Tables","body":"Our attractive multitouch coffee tables are perfect for relaxed lobby or lounge environments. The Pico & Duet models have 4K Ultra HD LG commercial display and 3M™ touch technology supporting 80 simultaneous touch points. Like our Presenter, Drafting, and Platform models, our touch coffee tables include a powerful computer system with Intel® Core™ processors and a NVIDIA® discrete graphics card. The tables require no assembly—just plug them in and turn them on.","links":[{"title":"Explore the Pico Smart Coffee Table","href":"https://ideum.com/products/touch-tables/pico"}],"images":[{"fileName":"ideum-coffee-table-wine--square--600.jpg","caption":"An innovative way to experience wines, using state-of-the-art Ideum multitouch tables that digitally identify the placement of wine glasses."},{"fileName":"ideum-coffee-table-02--1x1--635.jpg","caption":"The Ideum Duet is the coffee table of the future with 3M™ touch technology."},{"fileName":"ideum-coffee-table-03--1x1--635.jpg","caption":"The Tangible Engine Media Creator allows designers with little or no programming experience to build detailed and engaging mixed-reality applications."},{"fileName":"ideum-coffee-table-01--1x1--635.jpg","caption":""}]},{"name":"Presenter Touch Walls","title":"Presenter Multitouch Displays 55”, and 65” with Motorized Stand","body":"Our most versatile rental unit, the Presenter ships on a motorized stand which can be adjusted to function as either a touch table or touch wall. The Presenter has a 4K Ultra HD LG commercial display and 3M™ touch technology supporting 80 simultaneous touch points. It includes a powerful built-in computer system with Intel® Core™ processors and an NVIDIA® discrete graphics card. The Presenter is also available for rent without the stand if you would like it mounted on a wall for your event.","links":[{"title":"Explore Presenter Touch Walls","href":"https://ideum.com/touch-walls/presenter/"}],"images":[{"fileName":"ideum-presenter-07--1x1--635.jpg","caption":"Presenter Touch Wall with motorized stand offering multiple levels of adjustement for a vareity of scenarios."},{"fileName":"ideum-presenter-01--1x1--635.jpg","caption":"Explore and present information in interactive and engaging ways."},{"fileName":"ideum-presenter-03--1x1--635.jpg","caption":"The Presenter inter­active multi­touch walls use projected-capacitive techno­logy."},{"fileName":"ideum-presenter-04--1x1--635.jpg","caption":"Educate and share information with your audience with meaningful and memorable interactive experiences."}]},{"name":"Drafting Touch Tables","title":"Drafting 55” and 65” Tables","body":"Ideum’s drafting-style multitouch tables feature a tilted display screen at the classic drafting table angle. It’s very popular for kiosks and is a great way to showcase your content for the public. It features a 4K Ultra HD LG commercial display and 3M™ touch technology supporting 80 simultaneous touch points. The Drafting Table is equipped with a powerful computer system with Intel® Core™ processors and an NVIDIA® discrete graphics card. The tables require no assembly—just plug them in and turn them on.","links":[{"title":"Explore the Drafting Touch Table","href":"https://ideum.com/products/touch-tables/drafting/"}],"images":[{"fileName":"ideum-drafting-table-02--1x1--635.jpg","caption":"The Ideum Drafting Table available with 4K UHD resolution and the latest capacitive touch technology."},{"fileName":"ideum-drafting-table-01--1x1--635.jpg","caption":"All-in-one, turn­key, high-perfor­mance touch table in a classic drafting design, with 3M™ touch tech­nol­ogy."},{"fileName":"ideum-drafting-map--square--600.jpg","caption":"Explore a wide array of application types."},{"fileName":"ideum-drafting-table-04--1x1--635.jpg","caption":""}]},{"name":"Portrait Touch + Motion Kiosk","title":"Portrait Kiosk 55” Touch + Motion Kiosk","body":"The Portrait is a vertically oriented modular multitouch wall which can be used in a stand-alone setup or combined to transform any space into an immersive and interactive experience. As an option, this versatile display can also be outfitted with an integrated Kinect motion-sensing system. The Portrait Kiosk has an LG commercial 4K Ultra HD display and uses the latest in 3M™ project­ed-capacitive touch techno­logy with support for 80 touch points. The Portrait includes a powerful computer system with Intel® Core™ processors and an NVIDIA® discrete graphics card. The Portrait comes fully assembled—just plug it in and turn it on.","links":[{"title":"Explore the Portrait Touch Kiosk","href":"https://ideum.com/products/touch-walls/portrait"}],"images":[{"fileName":"ideum-portrait-02--1x1--635.jpg","caption":"The Portrait Kiosk is an all-in-one, vertically-oriented kiosk that can stand alone or be grouped together to create an expansive 4K UHD video wall."},{"fileName":"ideum-portrait-01--1x1--635.jpg","caption":"An all-in-one, 4K Ultra High De­fini­tion (UHD) 55” touch and motion-based kiosk for permanent exhibits or tempo­rary events."},{"fileName":"ideum-portrait-03--1x1--635.jpg","caption":""},{"fileName":"ideum-portrait-04--1x1--635.jpg","caption":""}]}]

/***/ }),

/***/ "IHu5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v("\b\n    "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73e5a3aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("a+4A");
function injectStyle (ssrContext) {
  __webpack_require__("dIZk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73e5a3aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73e5a3aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


// import { store } from './store/index'

__webpack_require__("8y8H");
__webpack_require__("erTq");

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
    // store
  } });

/***/ }),

/***/ "NU23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    classes: {
      type: Array,
      required: false
    }
  }
});

/***/ }),

/***/ "O4uX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    generateKey: function generateKey() {
      return Math.random() * Math.random();
    }
  }
});

/***/ }),

/***/ "O6sv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Tip"},[_c('header',{staticClass:"Tip-img Intrinsic-wrapper Intrinsic-wrapper--2x3"},[_c('img',{staticClass:"Intrinsic-item lazyload",attrs:{"data-src":'./static/images/' + _vm.imgFileName,"alt":"Ideum multitouch tables used for trade shows, events and interactive development."}})]),_vm._v(" "),_c('main',{staticClass:"Tip-wrapper"},[_vm._t("Tip-title"),_vm._v(" "),_vm._t("Tip-body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O8fB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OuUf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"container-fluid Navbar",class:{ 'is-opaque': !_vm.scrollIsHome }},[_c('div',{staticClass:"row d-md-none"},[_c('div',{staticClass:"col d-flex justify-content-end"},[_c('div',{staticClass:"Hamburger mt-3 mr-2",class:{ 'is-open': _vm.menuIsOpen },on:{"click":function($event){_vm.functionHandler(_vm.toggleMenu, _vm.toggleScroll)}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-right--fade"}},[(_vm.menuIsOpen)?_c('div',{staticClass:"Modal"},[_c('ul',{staticClass:"Modal-navList"},[_c('li',{staticClass:"Modal-navList-item",on:{"click":function($event){_vm.mobileNavigation('products')}}},[_vm._v("\n              Multitouch\n            ")]),_vm._v(" "),_c('li',{staticClass:"Modal-navList-item",on:{"click":function($event){_vm.mobileNavigation('story')}}},[_vm._v("\n              Story\n            ")]),_vm._v(" "),_c('li',{staticClass:"Modal-navList-item",on:{"click":function($event){_vm.mobileNavigation('creativeServices')}}},[_vm._v("\n              Creative Services\n            ")]),_vm._v(" "),_c('li',{staticClass:"Modal-navList-item",on:{"click":function($event){_vm.mobileNavigation('contact')}}},[_vm._v("\n              Contact\n            ")]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"Modal-navList-logo",staticStyle:{"enable-background":"new 0 0 223 84"},attrs:{"version":"1.1","id":"svg-logo-navbar","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 223 84","xml:space":"preserve"}},[_c('g',{attrs:{"id":"XMLID_93_"}},[_c('path',{staticClass:"st0",attrs:{"id":"XMLID_113_","d":"M73.7,27.6v55.3h-13v-5.4c-1.8,2.3-3.5,3.8-5,4.6c-2,1-4.2,1.6-6.7,1.6\n                  c-4.9,0-8.7-1.9-11.3-5.6c-2.6-3.8-3.9-8.3-3.9-13.7c0-6,1.4-10.6,4.3-13.8c2.9-3.2,6.5-4.8,11-4.8c2.2,0,4.1,0.4,5.9,1.1\n                  c1.8,0.7,3.3,1.8,4.7,3.3V27.6H73.7z M59.8,64.7c0-2.8-0.6-5-1.8-6.4s-2.7-2.1-4.6-2.1c-1.6,0-3,0.7-4.1,2s-1.6,3.6-1.6,6.8\n                  c0,3,0.6,5.1,1.7,6.5c1.1,1.4,2.5,2.1,4.2,2.1c1.8,0,3.3-0.7,4.4-2.1C59.2,70.1,59.8,67.8,59.8,64.7z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"id":"XMLID_109_","d":"M118.3,68.2H90.4c0.3,2.2,0.9,3.9,1.8,5c1.3,1.6,3.1,2.4,5.3,2.4c1.4,0,2.7-0.3,3.9-1\n                  c0.8-0.4,1.6-1.2,2.4-2.3l13.7,1.3c-2.1,3.6-4.6,6.3-7.6,7.8c-3,1.6-7.2,2.4-12.7,2.4c-4.8,0-8.6-0.7-11.3-2\n                  c-2.8-1.4-5-3.5-6.8-6.5c-1.8-2.9-2.7-6.4-2.7-10.4c0-5.7,1.8-10.3,5.4-13.8s8.6-5.3,15-5.3c5.2,0,9.3,0.8,12.3,2.4\n                  c3,1.6,5.3,3.8,6.9,6.8s2.4,6.9,2.4,11.6v1.6H118.3z M104.1,61.6c-0.3-2.7-1-4.6-2.2-5.8s-2.7-1.7-4.6-1.7c-2.2,0-4,0.9-5.3,2.6\n                  c-0.8,1.1-1.4,2.7-1.6,4.9H104.1z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"id":"XMLID_105_","d":"M158.9,82.9h-13V77c-1.9,2.4-3.9,4.1-5.9,5.2c-2,1-4.4,1.5-7.3,1.5c-3.8,0-6.8-1.1-9-3.4\n                  s-3.3-5.8-3.3-10.6v-23h14v19.9c0,2.3,0.4,3.9,1.3,4.8c0.8,1,2,1.4,3.5,1.4c1.7,0,3-0.6,4.1-1.9s1.6-3.6,1.6-6.9V46.7h13.9\n                  L158.9,82.9L158.9,82.9z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"id":"XMLID_102_","d":"M161.5,46.7h13V52c1.9-2.2,3.8-3.8,5.7-4.7s4.2-1.4,6.9-1.4c2.9,0,5.2,0.5,6.9,1.5\n                  s3.1,2.5,4.1,4.6c2.2-2.4,4.2-4,6-4.8c1.8-0.9,4-1.3,6.6-1.3c3.9,0,6.9,1.2,9.1,3.5c2.2,2.3,3.3,5.9,3.3,10.8V83h-13.9V62.2\n                  c0-1.6-0.3-2.9-1-3.7c-0.9-1.3-2.1-1.9-3.5-1.9c-1.6,0-2.9,0.6-3.9,1.8s-1.5,3.1-1.5,5.7v18.7h-13.9v-20c0-1.6-0.1-2.7-0.3-3.2\n                  c-0.3-0.9-0.8-1.6-1.5-2.2c-0.7-0.6-1.6-0.8-2.6-0.8c-1.6,0-2.9,0.6-3.9,1.8s-1.5,3.2-1.5,5.9v18.5h-13.9V46.7H161.5z"}}),_vm._v(" "),_c('g',{attrs:{"id":"XMLID_97_"}},[_c('circle',{staticClass:"st0",attrs:{"id":"XMLID_24_","cx":"24.4","cy":"33.6","r":"7.7"}}),_vm._v(" "),_c('g',{attrs:{"id":"XMLID_98_"}},[_c('circle',{staticClass:"st0",attrs:{"id":"XMLID_21_","cx":"24.4","cy":"33.6","r":"7.7"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"id":"XMLID_20_","d":"M17.6,43.2v39.7h13.9V43c-2,1.5-4.4,2.3-7,2.3C21.9,45.4,19.5,44.6,17.6,43.2z"}})])]),_vm._v(" "),_c('rect',{staticClass:"st0",attrs:{"id":"XMLID_17_","x":"22.8","y":"0.3","width":"3.3","height":"19"}}),_vm._v(" "),_c('rect',{staticClass:"st0",attrs:{"id":"XMLID_11_","x":"6.2","y":"7.2","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 -9.5175 10.4314)","width":"3.3","height":"19"}}),_vm._v(" "),_c('rect',{staticClass:"st0",attrs:{"id":"XMLID_5_","x":"31.4","y":"15.1","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 0.1533 33.8305)","width":"19","height":"3.3"}})])])])])]):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"container d-none d-md-block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 mx-auto"},[_c('ul',{staticClass:"Navbar-list mb-0 pr-0"},[_c('li',{staticClass:"Navbar-list-item Highlight",class:{ 
              'Highlight--emerald': _vm.currentSection === 'products', 
              'is-opaque': !_vm.scrollIsHome },on:{"click":function($event){_vm.jumpToSection('products')}}},[_vm._v("\n            Multitouch\n          ")]),_vm._v(" "),_c('li',{staticClass:"Navbar-list-item Highlight",class:{ 
              'Highlight--emerald': _vm.currentSection === 'products', 
              'is-opaque': !_vm.scrollIsHome },on:{"click":function($event){_vm.jumpToSection('story')}}},[_vm._v("\n            Story\n          ")]),_vm._v(" "),_c('li',{staticClass:"Navbar-list-item",on:{"click":_vm.jumpToHome}},[_c('svg',{staticClass:"Navbar-list-logo",class:{ 'is-opaque': !_vm.scrollIsHome },staticStyle:{"enable-background":"new 0 0 223 84"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 223 84","xml:space":"preserve"}},[_c('g',{attrs:{"id":"XMLID_93_"}},[_c('path',{staticClass:"st0",attrs:{"id":"XMLID_113_","d":"M73.7,27.6v55.3h-13v-5.4c-1.8,2.3-3.5,3.8-5,4.6c-2,1-4.2,1.6-6.7,1.6\n                  c-4.9,0-8.7-1.9-11.3-5.6c-2.6-3.8-3.9-8.3-3.9-13.7c0-6,1.4-10.6,4.3-13.8c2.9-3.2,6.5-4.8,11-4.8c2.2,0,4.1,0.4,5.9,1.1\n                  c1.8,0.7,3.3,1.8,4.7,3.3V27.6H73.7z M59.8,64.7c0-2.8-0.6-5-1.8-6.4s-2.7-2.1-4.6-2.1c-1.6,0-3,0.7-4.1,2s-1.6,3.6-1.6,6.8\n                  c0,3,0.6,5.1,1.7,6.5c1.1,1.4,2.5,2.1,4.2,2.1c1.8,0,3.3-0.7,4.4-2.1C59.2,70.1,59.8,67.8,59.8,64.7z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"id":"XMLID_109_","d":"M118.3,68.2H90.4c0.3,2.2,0.9,3.9,1.8,5c1.3,1.6,3.1,2.4,5.3,2.4c1.4,0,2.7-0.3,3.9-1\n                  c0.8-0.4,1.6-1.2,2.4-2.3l13.7,1.3c-2.1,3.6-4.6,6.3-7.6,7.8c-3,1.6-7.2,2.4-12.7,2.4c-4.8,0-8.6-0.7-11.3-2\n                  c-2.8-1.4-5-3.5-6.8-6.5c-1.8-2.9-2.7-6.4-2.7-10.4c0-5.7,1.8-10.3,5.4-13.8s8.6-5.3,15-5.3c5.2,0,9.3,0.8,12.3,2.4\n                  c3,1.6,5.3,3.8,6.9,6.8s2.4,6.9,2.4,11.6v1.6H118.3z M104.1,61.6c-0.3-2.7-1-4.6-2.2-5.8s-2.7-1.7-4.6-1.7c-2.2,0-4,0.9-5.3,2.6\n                  c-0.8,1.1-1.4,2.7-1.6,4.9H104.1z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"id":"XMLID_105_","d":"M158.9,82.9h-13V77c-1.9,2.4-3.9,4.1-5.9,5.2c-2,1-4.4,1.5-7.3,1.5c-3.8,0-6.8-1.1-9-3.4\n                  s-3.3-5.8-3.3-10.6v-23h14v19.9c0,2.3,0.4,3.9,1.3,4.8c0.8,1,2,1.4,3.5,1.4c1.7,0,3-0.6,4.1-1.9s1.6-3.6,1.6-6.9V46.7h13.9\n                  L158.9,82.9L158.9,82.9z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"id":"XMLID_102_","d":"M161.5,46.7h13V52c1.9-2.2,3.8-3.8,5.7-4.7s4.2-1.4,6.9-1.4c2.9,0,5.2,0.5,6.9,1.5\n                  s3.1,2.5,4.1,4.6c2.2-2.4,4.2-4,6-4.8c1.8-0.9,4-1.3,6.6-1.3c3.9,0,6.9,1.2,9.1,3.5c2.2,2.3,3.3,5.9,3.3,10.8V83h-13.9V62.2\n                  c0-1.6-0.3-2.9-1-3.7c-0.9-1.3-2.1-1.9-3.5-1.9c-1.6,0-2.9,0.6-3.9,1.8s-1.5,3.1-1.5,5.7v18.7h-13.9v-20c0-1.6-0.1-2.7-0.3-3.2\n                  c-0.3-0.9-0.8-1.6-1.5-2.2c-0.7-0.6-1.6-0.8-2.6-0.8c-1.6,0-2.9,0.6-3.9,1.8s-1.5,3.2-1.5,5.9v18.5h-13.9V46.7H161.5z"}}),_vm._v(" "),_c('g',{attrs:{"id":"XMLID_97_"}},[_c('circle',{staticClass:"st0",attrs:{"id":"XMLID_24_","cx":"24.4","cy":"33.6","r":"7.7"}}),_vm._v(" "),_c('g',{attrs:{"id":"XMLID_98_"}},[_c('circle',{staticClass:"st0",attrs:{"id":"XMLID_21_","cx":"24.4","cy":"33.6","r":"7.7"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"id":"XMLID_20_","d":"M17.6,43.2v39.7h13.9V43c-2,1.5-4.4,2.3-7,2.3C21.9,45.4,19.5,44.6,17.6,43.2z"}})])]),_vm._v(" "),_c('rect',{staticClass:"st0",attrs:{"id":"XMLID_17_","x":"22.8","y":"0.3","width":"3.3","height":"19"}}),_vm._v(" "),_c('rect',{staticClass:"st0",attrs:{"id":"XMLID_11_","x":"6.2","y":"7.2","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 -9.5175 10.4314)","width":"3.3","height":"19"}}),_vm._v(" "),_c('rect',{staticClass:"st0",attrs:{"id":"XMLID_5_","x":"31.4","y":"15.1","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 0.1533 33.8305)","width":"19","height":"3.3"}})])])]),_vm._v(" "),_c('li',{staticClass:"Navbar-list-item Highlight",class:{ 
              'Highlight--emerald': _vm.currentSection === 'products', 
              'is-opaque': !_vm.scrollIsHome },on:{"click":function($event){_vm.jumpToSection('creativeServices')}}},[_vm._v("\n            Creative Services\n          ")]),_vm._v(" "),_c('li',{staticClass:"Navbar-list-item Highlight",class:{ 
              'Highlight--emerald': _vm.currentSection === 'products', 
              'is-opaque': !_vm.scrollIsHome },on:{"click":function($event){_vm.jumpToSection('contact')}}},[_vm._v("\n            Contact\n          ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PCjG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QDf8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid Section--light"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-lg-4 mx-auto Reveal--sequenced"},[_c('app-tip',{attrs:{"imgFileName":'ideum-trade-shows--2x3--400.jpg'}},[_c('h4',{staticClass:"Tip-title",attrs:{"slot":"Tip-title"},slot:"Tip-title"},[_vm._v("\n              Trade Shows\n            ")]),_vm._v(" "),_c('p',{staticClass:"Tip-body",attrs:{"slot":"Tip-body"},slot:"Tip-body"},[_vm._v("\n              Stand out in the crowded trade show market by showing your products to clients using innovative and engaging multitouch technology.\n            ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-lg-4 mx-auto Reveal--sequenced"},[_c('app-tip',{attrs:{"imgFileName":'ideum-events--3x2--400.jpg'}},[_c('h4',{staticClass:"Tip-title",attrs:{"slot":"Tip-title"},slot:"Tip-title"},[_vm._v("\n              Events\n            ")]),_vm._v(" "),_c('p',{staticClass:"Tip-body",attrs:{"slot":"Tip-body"},slot:"Tip-body"},[_vm._v("\n              Provide an entertaining and engaging experience at your next event with an interactive multitouch table made by Ideum.\n            ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-lg-4 mx-auto Reveal--sequenced",staticStyle:{"z-index":"9"}},[_c('app-tip',{attrs:{"imgFileName":'ideum-development--2x3--400.jpg'}},[_c('h4',{staticClass:"Tip-title",attrs:{"slot":"Tip-title"},slot:"Tip-title"},[_vm._v("\n              Development\n            ")]),_vm._v(" "),_c('p',{staticClass:"Tip-body",attrs:{"slot":"Tip-body"},slot:"Tip-body"},[_vm._v("\n              Ideum's "),_c('a',{attrs:{"href":"http://gestureworks.com/","target":"_blank","rel":"noopener"}},[_vm._v("GestureWorks")]),_vm._v(" multitouch software framework and "),_c('a',{attrs:{"href":"https://tangibleengine.com/","target":"_blank","rel":"noopener"}},[_vm._v("Tangible Engine")]),_vm._v(", the innovative authoring solution for tangible user interaction, are also available.\n            ")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ri2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    imgFileName: {
      type: String,
      required: true
    }
  }
});

/***/ }),

/***/ "Rnn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Jumbotron_vue__ = __webpack_require__("u2ks");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4516f77a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Jumbotron_vue__ = __webpack_require__("yHfz");
function injectStyle (ssrContext) {
  __webpack_require__("x9dy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4516f77a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Jumbotron_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4516f77a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Jumbotron_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sczw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tip_vue__ = __webpack_require__("Ri2j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4275f92e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tip_vue__ = __webpack_require__("O6sv");
function injectStyle (ssrContext) {
  __webpack_require__("z9tm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4275f92e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4275f92e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TVmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("UthT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_000d693d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("jhDL");
function injectStyle (ssrContext) {
  __webpack_require__("O8fB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-000d693d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_000d693d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UYcH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UthT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_facebook_square__ = __webpack_require__("HbfR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_flickr__ = __webpack_require__("M6HL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_google_plus_square__ = __webpack_require__("EtTJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_instagram__ = __webpack_require__("Xau+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_linkedin_square__ = __webpack_require__("pqE5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_pinterest_square__ = __webpack_require__("MZXP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_twitter_square__ = __webpack_require__("WjU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_youtube_square__ = __webpack_require__("lwWl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__["a" /* default */]
  }
});

/***/ }),

/***/ "W7dn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y/4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreativeServices_vue__ = __webpack_require__("ZGF6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00898962_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreativeServices_vue__ = __webpack_require__("jZtn");
function injectStyle (ssrContext) {
  __webpack_require__("W7dn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00898962"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreativeServices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00898962_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreativeServices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZGF6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_data_projects_json__ = __webpack_require__("+pyK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_data_projects_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_data_projects_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Card__ = __webpack_require__("rhdv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Slider__ = __webpack_require__("2oac");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    appCard: __WEBPACK_IMPORTED_MODULE_1__Card__["a" /* default */],
    appSlider: __WEBPACK_IMPORTED_MODULE_2__Slider__["a" /* default */]
  },

  data: function data() {
    return {
      projects: __WEBPACK_IMPORTED_MODULE_0__static_data_projects_json___default.a
    };
  },


  computed: {
    imageLs: function imageLs() {
      var imageLs = [];
      imageLs.push(this.projects.images);
      return imageLs;
    }
  }
});

/***/ }),

/***/ "a+4A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"fade-in",attrs:{"id":"app"}},[_c('app-navbar'),_vm._v(" "),_c('app-jumbotron'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('app-card',{attrs:{"classes":['col-lg-10', 'col-xl-8', 'ml-auto', 'Card-wrapper--jumbo']}},[_c('h3',{staticClass:"Card-title",attrs:{"slot":"Card-title"},slot:"Card-title"},[_vm._v("\n          Multitouch Rentals\n        ")]),_vm._v(" "),_c('p',{attrs:{"slot":"Card-body"},slot:"Card-body"},[_vm._v("\n          Ideum rents its high-quality multitouch tables and touch displays directly to you. Our products’ clean, beautiful designs and durable construction will help you stand out, whether you are renting for a trade show, an exhibit, or another special event.\n        ")])])],1),_vm._v(" "),_c('app-products'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('app-card',{staticStyle:{"margin-top":"8em"},attrs:{"classes":['mr-auto', 'col-lg-10', 'col-xl-8', 'Reveal']}},[_c('h3',{staticClass:"Card-title",attrs:{"slot":"Card-title"},slot:"Card-title"},[_vm._v("Turnkey Solutions")]),_vm._v(" "),_c('p',{attrs:{"slot":"Card-body"},slot:"Card-body"},[_vm._v("\n          Ideum has been developing integrated multitouch systems for a decade. Our touch tables are found at the busiest public spaces in the world, including the Smithsonian Air and Space Museum in Washington, D.C. Our systems are made from aircraft grade aluminum and we use the latest and most reliable technology. And they are easy to set up—no technicians or assembly is required. If support is needed, we have a dedicated support line, and the same people who built our touch tables provide our timely support.\n        ")])])],1)],1),_vm._v(" "),_c('app-product-tips'),_vm._v(" "),_c('app-story'),_vm._v(" "),_c('app-creative-services'),_vm._v(" "),_c('app-contact'),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bXOk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tip__ = __webpack_require__("Sczw");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    appTip: __WEBPACK_IMPORTED_MODULE_0__Tip__["a" /* default */]
  }
});

/***/ }),

/***/ "dIZk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dOjO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_key__ = __webpack_require__("O4uX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hammerjs__ = __webpack_require__("rxKx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hammerjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: String,
      required: true
    },
    imageLs: {
      type: Array,
      required: true
    },
    classes: {
      type: Array,
      required: false
    }
  },

  data: function data() {
    return {
      currentImageIndex: 0,
      transitionName: 'slide-right--fade'
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_key__["a" /* default */]],

  methods: {
    imgHandler: function imgHandler(e) {
      var imgWidth = e.target.clientWidth;
      if (e.offsetX < imgWidth / 2) {
        this.prevImage();
      } else if (e.offsetX >= imgWidth / 2) {
        this.nextImage();
      }
    },
    preloadImg: function preloadImg(imageLs) {
      imageLs[0].forEach(function (imgObj) {
        var img = new Image();
        img.src = './static/images/' + imgObj.fileName;
      });
    },
    nextImage: function nextImage() {
      this.transitionName = 'slide-left--fade';
      if (this.currentImageIndex >= this.imageLs[0].length - 1) {
        this.currentImageIndex = 0;
      } else {
        this.currentImageIndex += 1;
      }
    },
    prevImage: function prevImage() {
      this.transitionName = 'slide-right--fade';
      if (this.currentImageIndex <= 0) {
        this.currentImageIndex = this.imageLs[0].length - 1;
      } else {
        this.currentImageIndex -= 1;
      }
    },
    swipeController: function swipeController(id) {
      var _this = this;

      var slider = document.getElementById(id);
      var mc = new __WEBPACK_IMPORTED_MODULE_1_hammerjs___default.a.Manager(slider);
      var swipe = new __WEBPACK_IMPORTED_MODULE_1_hammerjs___default.a.Swipe();
      mc.add(swipe, {
        touchAction: 'pan-y'
      });
      mc.on('swipeleft', function () {
        _this.nextImage();
      });
      mc.on('swiperight', function () {
        _this.prevImage();
      });
    }
  },

  mounted: function mounted() {
    this.swipeController(this.id);
    // this.preloadImg(this.imageLs)
  }
});

/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=["']?([^"')\s]+)/g, function (match, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ "eAZy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ecMZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_tips_vue__ = __webpack_require__("bXOk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_781233f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_tips_vue__ = __webpack_require__("QDf8");
function injectStyle (ssrContext) {
  __webpack_require__("eAZy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-781233f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_tips_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_781233f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_tips_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "engU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "erTq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j5Ze":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_data_products_json__ = __webpack_require__("HNjT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_data_products_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_data_products_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Slider__ = __webpack_require__("2oac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_key__ = __webpack_require__("O4uX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    appSlider: __WEBPACK_IMPORTED_MODULE_1__Slider__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_key__["a" /* default */]],

  data: function data() {
    return {
      currentProductIndex: 0,
      products: __WEBPACK_IMPORTED_MODULE_0__static_data_products_json___default.a
    };
  }
});

/***/ }),

/***/ "jZtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container Section Section--creativeServices"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6",staticStyle:{"z-index":"1"}},[_c('app-slider',{attrs:{"id":'creativeServices',"imageLs":_vm.imageLs,"classes":[ 'Intrinsic-wrapper--5x4', 'Reveal' ]}})],1),_vm._v(" "),_c('app-card',{attrs:{"classes":['col-lg-6', 'mt-4', 'mt-lg-0', 'ml-auto', 'Reveal']}},[_c('h3',{staticClass:"Card-title",attrs:{"slot":"Card-title"},slot:"Card-title"},[_vm._v("\n        Unique Software for Your Event\n      ")]),_vm._v(" "),_c('p',{staticClass:"mt-5",attrs:{"slot":"Card-body"},slot:"Card-body"},[_vm._v("\n        Ideum's Creative Services team can be contracted to help you develop a unique custom application for your event. Ideum has deep experience in interaction design, tangible user interface design, and multitouch / multiuser installations. We have a diverse range of design experience and can work with budgets of varying sizes. We work regularly with world-class museums, Fortune 500 companies, nonprofits, and government agencies to create compelling interactive experiences.\n      ")]),_vm._v(" "),_c('footer',{attrs:{"slot":"Card-button"},slot:"Card-button"},[_c('a',{staticClass:"Button Button--emerald mt-4",attrs:{"target":"_blank","href":"http://ideum.com/work","title":"Learn more about Ideum's Creative Services","rel":"noopener"}},[_c('span',{staticClass:"Button-text"},[_vm._v("Explore Creative Services")])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jhDL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"container-fluid Section Section--footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 text-center text-sm-left"},[_c('a',{attrs:{"href":"https://ideum.com","target":"_blank","rel":"noopener","title":"Ideum.com"}},[_c('svg',{staticClass:"Section--footer-logo",staticStyle:{"enable-background":"new 0 0 223 84"},attrs:{"version":"1.1","id":"svg-logo-footer","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 223 84","xml:space":"preserve"}},[_c('g',{attrs:{"id":"XMLID_93_"}},[_c('path',{staticClass:"st0",attrs:{"id":"XMLID_113_","d":"M73.7,27.6v55.3h-13v-5.4c-1.8,2.3-3.5,3.8-5,4.6c-2,1-4.2,1.6-6.7,1.6\n              c-4.9,0-8.7-1.9-11.3-5.6c-2.6-3.8-3.9-8.3-3.9-13.7c0-6,1.4-10.6,4.3-13.8c2.9-3.2,6.5-4.8,11-4.8c2.2,0,4.1,0.4,5.9,1.1\n              c1.8,0.7,3.3,1.8,4.7,3.3V27.6H73.7z M59.8,64.7c0-2.8-0.6-5-1.8-6.4c-1.2-1.4-2.7-2.1-4.6-2.1c-1.6,0-3,0.7-4.1,2\n              c-1.1,1.3-1.6,3.6-1.6,6.8c0,3,0.6,5.1,1.7,6.5c1.1,1.4,2.5,2.1,4.2,2.1c1.8,0,3.3-0.7,4.4-2.1C59.2,70.1,59.8,67.8,59.8,64.7z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"id":"XMLID_109_","d":"M118.3,68.2H90.4c0.3,2.2,0.9,3.9,1.8,5c1.3,1.6,3.1,2.4,5.3,2.4c1.4,0,2.7-0.3,3.9-1\n              c0.8-0.4,1.6-1.2,2.4-2.3l13.7,1.3c-2.1,3.6-4.6,6.3-7.6,7.8c-3,1.6-7.2,2.4-12.7,2.4c-4.8,0-8.6-0.7-11.3-2\n              c-2.8-1.4-5-3.5-6.8-6.5c-1.8-2.9-2.7-6.4-2.7-10.4c0-5.7,1.8-10.3,5.4-13.8c3.6-3.5,8.6-5.3,15-5.3c5.2,0,9.3,0.8,12.3,2.4\n              c3,1.6,5.3,3.8,6.9,6.8c1.6,3,2.4,6.9,2.4,11.6V68.2z M104.1,61.6c-0.3-2.7-1-4.6-2.2-5.8c-1.2-1.2-2.7-1.7-4.6-1.7\n              c-2.2,0-4,0.9-5.3,2.6c-0.8,1.1-1.4,2.7-1.6,4.9H104.1z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"id":"XMLID_105_","d":"M158.9,82.9h-13V77c-1.9,2.4-3.9,4.1-5.9,5.2c-2,1-4.4,1.5-7.3,1.5c-3.8,0-6.8-1.1-9-3.4\n              c-2.2-2.3-3.3-5.8-3.3-10.6V46.7h14v19.9c0,2.3,0.4,3.9,1.3,4.8c0.8,1,2,1.4,3.5,1.4c1.7,0,3-0.6,4.1-1.9c1.1-1.3,1.6-3.6,1.6-6.9\n              V46.7h13.9V82.9z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"id":"XMLID_102_","d":"M161.5,46.7h13v5.3c1.9-2.2,3.8-3.8,5.7-4.7c1.9-0.9,4.2-1.4,6.9-1.4c2.9,0,5.2,0.5,6.9,1.5\n              c1.7,1,3.1,2.5,4.1,4.6c2.2-2.4,4.2-4,6-4.8c1.8-0.9,4-1.3,6.6-1.3c3.9,0,6.9,1.2,9.1,3.5c2.2,2.3,3.3,5.9,3.3,10.8v22.8h-13.9\n              V62.2c0-1.6-0.3-2.9-1-3.7c-0.9-1.3-2.1-1.9-3.5-1.9c-1.6,0-2.9,0.6-3.9,1.8c-1,1.2-1.5,3.1-1.5,5.7v18.7h-13.9v-20\n              c0-1.6-0.1-2.7-0.3-3.2c-0.3-0.9-0.8-1.6-1.5-2.2c-0.7-0.6-1.6-0.8-2.6-0.8c-1.6,0-2.9,0.6-3.9,1.8c-1,1.2-1.5,3.2-1.5,5.9v18.5\n              h-13.9V46.7z"}}),_vm._v(" "),_c('g',{attrs:{"id":"XMLID_97_"}},[_c('circle',{staticClass:"st0",attrs:{"id":"XMLID_24_","cx":"24.4","cy":"33.6","r":"7.7"}}),_vm._v(" "),_c('g',{attrs:{"id":"XMLID_98_"}},[_c('circle',{staticClass:"st0",attrs:{"id":"XMLID_21_","cx":"24.4","cy":"33.6","r":"7.7"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"id":"XMLID_20_","d":"M17.6,43.2v39.7h13.9V43c-2,1.5-4.4,2.3-7,2.3C21.9,45.4,19.5,44.6,17.6,43.2z"}})])]),_vm._v(" "),_c('rect',{staticClass:"st0",attrs:{"id":"XMLID_17_","x":"22.8","y":"0.3","width":"3.3","height":"19"}}),_vm._v(" "),_c('rect',{staticClass:"st0",attrs:{"id":"XMLID_11_","x":"6.2","y":"7.2","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 -9.5262 10.4465)","width":"3.3","height":"19"}}),_vm._v(" "),_c('rect',{staticClass:"st0",attrs:{"id":"XMLID_5_","x":"39.3","y":"7.2","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 58.0609 57.4945)","width":"3.3","height":"19"}})])])]),_vm._v(" "),_c('p',{staticClass:"Section--footer-legal"},[_vm._v("© Ideum. All rights reserved.")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-2 d-flex flex-column justify-content-center mx-auto text-center text-sm-left"},[_c('h3',{staticClass:"Section--footer-heading"},[_vm._v("Follow Us")]),_vm._v(" "),_c('ul',{staticClass:"Section--footer-list"},[_c('li',{staticClass:"Section--footer-list-item"},[_c('a',{attrs:{"href":"https://www.facebook.com/ideum/","target":"_blank","title":"Ideum on Facebook","rel":"noopener"}},[_c('icon',{attrs:{"name":"facebook-square","scale":"1.5"}})],1)]),_vm._v(" "),_c('li',{staticClass:"Section--footer-list-item"},[_c('a',{attrs:{"href":"https://www.flickr.com/photos/ideum/","target":"_blank","title":"Ideum on Flickr","rel":"noopener"}},[_c('icon',{attrs:{"name":"flickr","scale":"1.5"}})],1)]),_vm._v(" "),_c('li',{staticClass:"Section--footer-list-item"},[_c('a',{attrs:{"href":"https://www.instagram.com/ideum/","target":"_blank","title":"Ideum on Instagram","rel":"noopener"}},[_c('icon',{attrs:{"name":"instagram","scale":"1.5"}})],1)]),_vm._v(" "),_c('li',{staticClass:"Section--footer-list-item"},[_c('a',{attrs:{"href":"https://www.linkedin.com/company/ideum/","target":"_blank","title":"Ideum on LinkedIn","rel":"noopener"}},[_c('icon',{attrs:{"name":"linkedin-square","scale":"1.5"}})],1)]),_vm._v(" "),_c('li',{staticClass:"Section--footer-list-item"},[_c('a',{attrs:{"href":"https://twitter.com/ideum?lang=en","target":"_blank","title":"Ideum on Twitter","rel":"noopener"}},[_c('icon',{attrs:{"name":"twitter-square","scale":"1.5"}})],1)]),_vm._v(" "),_c('li',{staticClass:"Section--footer-list-item"},[_c('a',{attrs:{"href":"https://www.youtube.com/user/multitouchexhibits/","target":"_blank","title":"Ideum on YouTube","rel":"noopener"}},[_c('icon',{attrs:{"name":"youtube-square","scale":"1.5"}})],1)]),_vm._v(" "),_c('li',{staticClass:"Section--footer-list-item"},[_c('a',{attrs:{"href":"https://www.pinterest.com/ideum/","target":"_blank","title":"Ideum on Pinterest","rel":"noopener"}},[_c('icon',{attrs:{"name":"pinterest-square","scale":"1.5"}})],1)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3 d-flex flex-column justify-content-center mb-4 mb-sm-0 ml-auto text-center text-sm-left"},[_c('ul',{staticClass:"Section--footer-list"},[_c('li',[_c('a',{attrs:{"href":"https://ideum.com/support","target":"_blank","title":"Ideum Support","rel":"noopener"}},[_vm._v("\n              Support\n            ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://ideum.com/legal","target":"_blank","title":"Ideum Privacy & Legal Terms","rel":"noopener"}},[_vm._v("\n              Privacy & Terms\n            ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kMkV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lfLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("Drc2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c280e59c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("OuUf");
function injectStyle (ssrContext) {
  __webpack_require__("trIj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c280e59c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c280e59c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mBSZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__ = __webpack_require__("j5Ze");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_552403f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__ = __webpack_require__("wHJA");
function injectStyle (ssrContext) {
  __webpack_require__("UYcH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-552403f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_552403f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "msts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid Section Section--contact"},[_c('div',{staticClass:"container mt-5"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-7 Reveal"},[_c('div',{staticClass:"Intrinsic-wrapper Intrinsic-wrapper--5x4"},[_c('img',{staticClass:"Intrinsic-item lazyload",attrs:{"data-src":'./static/images/' + 'ideum-contact-touch--4x5--600.jpg',"alt":"Hiqh-quality, custom-made multitouch table created by Ideum."}})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-5 d-flex flex-column justify-content-center mb-5 mb-lg-0 px-lg-5"},[_c('h2',{staticClass:"Reveal--sequenced"},[_vm._v("Contact Us")]),_vm._v(" "),_c('p',{staticClass:"Reveal--sequenced"},[_vm._v("\n          For questions, bookings, and availability, please contact us at (505) 792-1110 ext.1 or toll-free in the US (855) 898-6824, use our online inquiry form, or email us at sales@ideum.com. At this time, rentals are only available in the United States.\n        ")]),_vm._v(" "),_c('a',{staticClass:"Button Button--emerald mt-4 Reveal--sequenced",attrs:{"target":"_blank","href":"https://ideum.com/contact","title":"Contact Rentals at Ideum","rel":"noopener"}},[_c('span',{staticClass:"Button-text"},[_vm._v("Contact Ideum")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qkoT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rhdv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__("NU23");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72f786b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__("Agty");
function injectStyle (ssrContext) {
  __webpack_require__("qkoT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72f786b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72f786b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sgJx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "trIj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u2ks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "uTqV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Story_vue__ = __webpack_require__("sgJx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6327e943_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Story_vue__ = __webpack_require__("BTA2");
function injectStyle (ssrContext) {
  __webpack_require__("engU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6327e943"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Story_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6327e943_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Story_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wHJA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"row position-relative Section Section--products",staticStyle:{"margin-top":"7em"}},[_c('div',{staticClass:"col-md-7 Reveal--left"},[_c('h2',{staticClass:"Product-title"},[_vm._v("Multitouch Platforms")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-10"},[_c('ul',{attrs:{"Class":"ProductList"}},_vm._l((_vm.products),function(product,i){return _c('li',{key:'productList-' + i,staticClass:"ProductList-item Highlight--emerald",class:{ 'Highlight': _vm.currentProductIndex === i },on:{"click":function($event){_vm.currentProductIndex = i}}},[_vm._v("\n            "+_vm._s(product.name)+"\n          ")])}))])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},_vm._l((_vm.products),function(product,i){return (_vm.currentProductIndex === i)?_c('app-slider',{key:'product-' + i,attrs:{"id":product.name,"imageLs":[product.images],"classes":[ 'Intrinsic-wrapper--square' ]}}):_vm._e()}))],1),_vm._v(" "),_c('div',{staticClass:"col-md-5 pl-lg-5 pl-md-4 Product"},[_c('p',{staticClass:"Product-category Reveal--sequenced--right"},[_vm._v("\n      "+_vm._s(_vm.products[_vm.currentProductIndex].name)+"\n    ")]),_vm._v(" "),_c('h3',{staticClass:"Product-subtitlte Reveal--sequenced--right"},[_vm._v("\n      "+_vm._s(_vm.products[_vm.currentProductIndex].title)+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"Product-body Reveal--sequenced--right"},[_vm._v("\n      "+_vm._s(_vm.products[_vm.currentProductIndex].body)+"\n    ")]),_vm._v(" "),_c('a',{staticClass:"Button Button--emerald Reveal--sequenced--right",attrs:{"target":"_blank","rel":"noopener","href":_vm.products[_vm.currentProductIndex].links[0].href,"title":_vm.products[_vm.currentProductIndex].links[0].title}},[_c('span',{staticClass:"Button-text"},[_vm._v(_vm._s(_vm.products[_vm.currentProductIndex].links[0].title))])])]),_vm._v(" "),_c('div',{staticClass:"Background Background--light",staticStyle:{"top":"-35%","left":"-10%","width":"100%","height":"170%"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x9dy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Card__ = __webpack_require__("rhdv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Jumbotron__ = __webpack_require__("Rnn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Navbar__ = __webpack_require__("lfLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Products__ = __webpack_require__("mBSZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Product_tips__ = __webpack_require__("ecMZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Story__ = __webpack_require__("uTqV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CreativeServices__ = __webpack_require__("Y/4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Contact__ = __webpack_require__("FnhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Footer__ = __webpack_require__("TVmP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










__webpack_require__("B2fU");
var ScrollReveal = __webpack_require__("Nqmp");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  components: {
    appCard: __WEBPACK_IMPORTED_MODULE_0__components_Card__["a" /* default */],
    appJumbotron: __WEBPACK_IMPORTED_MODULE_1__components_Jumbotron__["a" /* default */],
    appNavbar: __WEBPACK_IMPORTED_MODULE_2__components_Navbar__["a" /* default */],
    appProducts: __WEBPACK_IMPORTED_MODULE_3__components_Products__["a" /* default */],
    appProductTips: __WEBPACK_IMPORTED_MODULE_4__components_Product_tips__["a" /* default */],
    appStory: __WEBPACK_IMPORTED_MODULE_5__components_Story__["a" /* default */],
    appCreativeServices: __WEBPACK_IMPORTED_MODULE_6__components_CreativeServices__["a" /* default */],
    appContact: __WEBPACK_IMPORTED_MODULE_7__components_Contact__["a" /* default */],
    appFooter: __WEBPACK_IMPORTED_MODULE_8__components_Footer__["a" /* default */]
  },

  mounted: function mounted() {
    window.sr = ScrollReveal({
      duration: 1000,
      scale: 1
    });
    window.sr.reveal('.Reveal');
    window.sr.reveal('.Reveal--right', {
      delay: 500
    });
    window.sr.reveal('.Reveal--left', {
      origin: 'left'
    });
    window.sr.reveal('.Reveal--sequenced', {
      delay: 250,
      distance: '10vh'
    }, 250);
    window.sr.reveal('.Reveal--sequenced--right', {
      delay: 250,
      origin: 'right'
    }, 250);
  }
});

/***/ }),

/***/ "xjma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Slider",on:{"mouseover":function($event){_vm.preloadImg(_vm.imageLs)}}},[_c('div',{staticClass:"Slider-wrapper Intrinsic-wrapper",class:_vm.classes,attrs:{"id":_vm.id}},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"in-out"}},_vm._l((_vm.imageLs[0]),function(img,i){return (_vm.currentImageIndex === i)?_c('img',{key:i,staticClass:"Slider-wrapper-img Intrinsic-item lazyload",attrs:{"data-src":'./static/images/' + img.fileName,"alt":img.caption},on:{"click":_vm.imgHandler}}):_vm._e()})),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},_vm._l((_vm.imageLs[0]),function(img,i){return (_vm.currentImageIndex === i && img.caption !== '')?_c('footer',{key:'img-' + i,staticClass:"Slider-footer"},[_c('p',{staticClass:"Slider-footer-body"},[_vm._v("\n        "+_vm._s(img.caption)+"\n      ")])]):_vm._e()}))],1),_vm._v(" "),_c('div',[_c('ul',{staticClass:"Slider-map"},_vm._l((_vm.imageLs[0]),function(image,i){return _c('li',{key:'image-' + i,staticClass:"Slider-map-dot",class:{ 'is-active': _vm.currentImageIndex === i },on:{"click":function($event){_vm.currentImageIndex = i}}})}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yHfz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container-fluid Jumbotron"},[_c('header',{staticClass:"container TitleCard"},[_c('div',{staticClass:"row Section"},[_c('div',{staticClass:"col-md-10 col-lg-8"},[_c('h1',{staticClass:"TitleCard-title"},[_vm._v("Rent a Cutting-Edge "),_c('span',{staticClass:"Highlight Highlight--emerald Highlight--tall"},[_vm._v("Touch Table")]),_vm._v(" or "),_c('span',{staticClass:"Highlight Highlight--emerald Highlight--tall"},[_vm._v("Interactive Display")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('p',{staticClass:"TitleCard-subtitle"},[_vm._v("Engage the audience at your next event or trade show by providing a truly memorable interactive experience with Ideum’s multitouch tables and displays.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z9tm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6cf9caf4ae35db9db9fc.js